import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { EditableSection } from '®shared/reading-list/models';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rl-view-section',
  templateUrl: './view-section.component.html',
})
export class ViewSectionComponent implements OnDestroy {
  @Input() section: EditableSection;
  @Input() depth = 0;

  private stickyFilterBarTopOffsetSubscription: Subscription;

  sectionAnchorTopOffset: number;

  get sectionHeadingLevel(): number {
    // The first section has a depth of 0, but the list title uses H1 (level 1)
    return this.depth + 2;
  }

  ngOnDestroy(): void {
    if (this.stickyFilterBarTopOffsetSubscription) {
      this.stickyFilterBarTopOffsetSubscription.unsubscribe();
    }
  }
}
